<template>
    <div class="right-bar__ruler source-code">
        <h3 class="right-bar__header">{{ $t('translation.sourceCode') }}</h3>

        <div class="col">
            <textarea :value="code" class="source-code__body"></textarea>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            code: {
                required: false,
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/Code/rightbar/SourceCode.vue